import services from "@src/Services";
import { getCustomExtraPathDashboard } from "../../helper";
import { CHECK_TYPE } from "../helper";

export const getSummaryData = async (filters: FilterType) => {
  try {
    const advancedFilterExtraPath = getCustomExtraPathDashboard({ ...filters });

    const customPath = `${advancedFilterExtraPath}`;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const res: any = await services.get(`/notification-summary${customPath}`);
    if (!res?.error) {
      return { data: res?.data?.data };
    }
    return { data: null, error: "Something went wrong !" };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    return {
      error: err?.error?.message || "Something went wrong!",
    };
  }
};

export const getMappedSummaryData = (mapData: NotificationSummaryDataType) => {
  const data = [
    {
      type: CHECK_TYPE.DISCOUNT,
      value: mapData?.discounts,
    },
    {
      type: CHECK_TYPE.VOID,
      value: mapData?.voids,
    },
    {
      type: CHECK_TYPE.TIP,
      value: mapData?.tips,
    },
  ];
  return data;
};

export const summaryInitialState = {
  discounts: undefined,
  last_updated: undefined,
  tips: undefined,
  voids: undefined,
};
